export default __webpack_public_path__ + "static/dome-f05f0fbfa752101e1359a8b6b668c4fa.png";